import React from "react";
import { Metric } from "components/Utils/Utils.js";
import Heading from "components/Elements/Heading";

const HearstFilteredSummary = (props) => {
  const { data } = props;

  return (
    <div className="row">
      <div className="col-6 col-md-4 mb-3 mb-md-0">
        <Heading size={5} className={"mb-1"}>
          Video Completion Rate
        </Heading>
        <Metric
          {...data.data.video_completion_rate}
          size={"md"}
          type={"percentage"}
        />
      </div>

      <div className="col-6 col-md-4 mb-3">
        <Heading size={5} className={"mb-1"}>
          Video Impressions
        </Heading>
        <Metric {...data.data.video_impressions} size={"md"} />
      </div>

      <div className="col-6 col-md-4 mb-3 ">
        <Heading size={5} className={"mb-1"}>
          Video Completions
        </Heading>
        <Metric {...data.data.video_views_complete} size={"md"} />
      </div>
    </div>
  );
};

export default HearstFilteredSummary;
